import { Skeleton } from '@mui/material';
import Column from '../../../../components/Column';

const defaultOuterDiameter = 280;
const defaultInnerDiameter = 170;

export default function HatDbVisualSkeletonPieChart(props: {
    outerDiameter?: number;
    innerDiameter?: number;
    marginTop?: string;
    marginBottom?: string;
}) {
    const { outerDiameter, innerDiameter, marginTop, marginBottom } = props;

    return (
        <Column
            alignItems="center"
            justifyContent="center"
            sx={{
                position: 'relative',
                marginTop: marginTop ?? '0',
                marginBottom: marginBottom ?? '0',
            }}
        >
            <Skeleton
                variant="circular"
                width={outerDiameter ?? defaultOuterDiameter}
                height={outerDiameter ?? defaultOuterDiameter}
            />

            <Skeleton
                variant="circular"
                width={innerDiameter ?? defaultInnerDiameter}
                height={innerDiameter ?? defaultInnerDiameter}
                animation={false}
                sx={{
                    position: 'absolute',
                    bgcolor: 'white',
                }}
            />

            <Column
                gap={0.5}
                alignItems="center"
                justifyContent="center"
                sx={{
                    position: 'absolute',
                }}
            >
                <Skeleton
                    variant="text"
                    width={120}
                    sx={{
                        fontSize: '1.50rem',
                    }}
                />

                <Skeleton
                    variant="text"
                    width={80}
                    sx={{
                        fontSize: '1rem',
                    }}
                />
            </Column>
        </Column>
    );
}
